import React from 'react';
import { Form, Row, Col, Select, Alert } from 'antd';
import { EXTEND_VIGNETTE_ROUTE } from 'constants/index';
import StepCard from 'components/StepCard';
import { FormattedMessage } from 'react-intl';

import './styles.scss';

const { Option } = Select;
let timer;

class DirectMandate extends React.Component {
  state = {
    bank: null,
  };
  componentDidMount() {
    if (this.props.getBankLists) {
      this.props.getBankLists();
      return;
    } else {
      this.props.getBanks();
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        sessionStorage.setItem('bank', values.bank);
        this.setState({ visible: true });
        this.props.postDirect(values.bank);
      }
    });
  };

  renderServerErrorMsg = () => {
    const { error } = this.props;
    if (error) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.setState({ visible: false });
      }, 5000);
      if (this.state.visible) {
        return (
          <div className="error-msg">
            <Alert description={error} type="error" />
          </div>
        );
      }
    }
  };
  renderMoreDetails = () => {
    return (
      <p>
        <FormattedMessage id="extend.bank.not.listed" />
        <br />
        <FormattedMessage id="extend.bank.authorization" />
      </p>
    );
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <StepCard
        isLoading={this.props.isFetchingBanks}
        onPrevious={() => this.props.onPrevious()}
        onNext={this.handleSubmit}
        className="extend-direct-lists"
        current={this.props.current}
        steps={this.props.steps}
        id={this.props.id}
        isNextLoading={this.props.isNextLoading}
      >
        <Row className="card-wrapper align-center">
          <Col span={24} xs={24} lg={4} md={24} sm={24}>
            <img src={require('assets/direct.svg')} alt="direct" />
          </Col>
          <Col span={24} xs={24} lg={17} md={24} sm={24}>
            <div className="bank-info">
              <span className="bank-title">
                <FormattedMessage id="extend.step.payment.bank.ideal" />
              </span>
              <Form.Item>
                {getFieldDecorator('bank', {
                  rules: [
                    {
                      required: true,
                      message: <FormattedMessage id="required.error" />,
                    },
                  ],
                })(
                  <Select
                    style={{ width: '80%' }}
                    placeholder={
                      <FormattedMessage id="extend.step.payment.select.bank" />
                    }
                    onChange={this.onChange}
                  >
                    {this.props.banks && this.props.banks.length
                      ? this.props.banks.map(data => {
                          return (
                            <Option value={data.DebtorBankId} key={data.id}>
                              {data.DebtorBankName}
                            </Option>
                          );
                        })
                      : null}
                  </Select>,
                )}
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row type="flex" align="center">
          {this.renderServerErrorMsg()}
        </Row>
      </StepCard>
    );
  }
}

const DirectMandateForm = Form.create({ name: 'DirectMandate' })(DirectMandate);

export default DirectMandateForm;
